<script lang="ts">
  import { imgSrc } from "$lib/serv/image-details";
  import { selectAddress } from "$lib/ui/modals/AddressModal.svelte";
  import { KEY_GROUP } from "../food/TileStack.svelte";

	export let item: {name?:string, description?:string, banner?:string, logo?:string, adminId?:string};

	function selectAddr() {
		selectAddress(false, item.adminId ? [[KEY_GROUP, item.adminId]] : []);
	}
</script>

<section class="item">
	<img src={imgSrc(item.banner)} alt={item.name}><!-- TODO: fix FEW-1465 and FEW-1462 -->
	<article class="item">
		<div class="image-container">
			<div><img src={imgSrc(item.banner)} alt={`${item.name} near me`}></div>
			<div><img src={imgSrc(item.logo)} alt={`${item.name} near me`}></div>
		</div>
		<div class="text-container">
			<h4 class="body-l ellipses">{item.name}</h4>
			<p class="body-s"></p><!--{item.description}--><!-- SEO Paul asked to have this removed due to content clashing with copy blocks --> 
			<button class="button small white" on:click={() => selectAddr()}>Order now</button>
		</div>
	</article>
</section>

<style lang="scss">
	@use 'color';

	section {
		width: 244px;
		max-width: 244px;
		min-width: 244px;
		border-radius: 28px;
		box-shadow: 0px 0px 0px 1.5px color.$separator, 0px 4px 9px 2px rgba(0,0,0,0.3);
		margin: .8rem .5rem;
		z-index: 1;
		>img {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 28px;
		}
		article {
			background-color: rgba(0,0,0,0.5);
			backdrop-filter: blur(50px);
			-webkit-backdrop-filter: blur(50px);
			position: relative;
			display: flex;
			flex-direction: column;
			width: 244px;
			max-width: 244px;
			border-radius: 28px;
			padding: 7px;
			overflow: hidden;
			z-index: 0;
			transition: all .3s ease;
			&:hover {
				background-color: rgba(0,0,0,0.1);
			}
			.image-container {
				position: relative;
				div {
					&:nth-child(1) {
						position: relative;
						width: 100%;
						height: 132px;
						border-radius: 20px;
						box-shadow: -1px -1px rgba(255, 255, 255, 0.3), 0 0 3px rgba(0,0,0,0.55);
						overflow: hidden;
						>img {
							position: absolute;
							top: 0;
							left: 0;
							width: 100%;
							height: 100%;
							object-fit: cover;
						}
					}
					&:nth-child(2) {
						background: color.$white;
						position: absolute;
						display: flex;
						justify-content: center;
						align-items: center;
						left: 8px;
						bottom: -.8rem;
						width: 56px;
						height: 56px;
						border-radius: 10px;
						box-shadow: 0 4px 4px rgba(0,0,0,.35);
						overflow: hidden;
					}
				}
			}
			.text-container {
				margin: 1.5rem 0 0.85rem 0;
				padding: 0 0.8rem;
				color: color.$white;
				h4 { margin: 0; }
				p { 
					margin: 0.3rem 0 1rem 0;
					color: color.$white;
					opacity: .75;
					-webkit-line-clamp: 3;
					display: -webkit-box;
					text-overflow: ellipsis;
					-webkit-box-orient: vertical;
					overflow: hidden;
				}
				button {
					&:hover { background: color.$white; }
				}
			}
		}
	}

	
</style>